import type { ExpandedItems } from '@atlassian/jira-business-list-handlers/src/controllers/children/types.tsx';
import type { Item } from '@atlassian/timeline-table/common/types/item';
import { getTimelineTableItemsHeight } from '../../../common/utils/get-items-height/index.tsx';
import type { TimelineViewIssue } from '../../../services/get-timeline-view-issues/types.tsx';

export const getIssueAfter = (
	containerHeight: number,
	expandedItems: ExpandedItems,
	height: number,
	issuesMap: Map<string, TimelineViewIssue>,
	items: Item[],
	timelineRef: HTMLElement | null | undefined,
): TimelineViewIssue | undefined => {
	// This selector represents the scrollable element of the timeline table platform component.
	const scrollTop = timelineRef?.querySelector('#sr-timeline')?.scrollTop ?? 0;

	/**
	 * 2.5 here represented by
	 * - 1 height of the inline create itself, we want the anchor to be above the inline create bar
	 * - 1 height is for to target the starting point of issue visible above inline create bar
	 * - 0.5 height is to adjust so that the NEWLY created issue will always be 100%  visible without scrolling
	 * (in other words, requires the last issue to be visible more than 50% of the height to be considered as anchor, if it is less than 50% shown, we pick the issue before)
	 */
	const maxHeightForAnchor = containerHeight + scrollTop - height * 2.5;

	// we loop through all items to pick the most appropriate issue as the anchor
	// and make sure the issue is less than the maxHeightForAnchor
	let offset = 0;
	let itemIndexForStickyAnchor = 0;
	items.forEach((item, index) => {
		if (offset < maxHeightForAnchor) {
			itemIndexForStickyAnchor = index;
			offset += height;

			// check if it is in expanded state
			if (expandedItems[item.id]) {
				// if yes, we want to sum the children height
				offset += getTimelineTableItemsHeight(item.childItems, expandedItems, height, false);
			}
		}
	});

	const item = items[itemIndexForStickyAnchor];
	return item ? issuesMap.get(item.id) : undefined;
};
